<template>
<div>
    <!-- НИЖНЯЯ НАВИГАЦИЯ -->
    <nav class="nnav" :aria-label="$t('m_nav_menu')">
        <div class="nnav__inner">
            <button class="nnav__item" :class="{ 'is-on': isMenu }" :aria-current="isMenu ? 'page' : null" @click="go('vendor')">
                <span class="nnav__ico">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M4 5.5h16M4 12h16M4 18.5h10"/>
                    </svg>
                </span>
                <span class="nnav__lbl">{{ $t('m_nav_menu') }}</span>
            </button>

            <button class="nnav__item" :class="{ 'is-on': isAbout }" :aria-current="isAbout ? 'page' : null" @click="go('about')">
                <span class="nnav__ico">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M4 20.5V9.2L12 4l8 5.2v11.3"/><path d="M9.5 20.5v-6h5v6"/><path d="M2.5 20.5h19"/>
                    </svg>
                </span>
                <span class="nnav__lbl">{{ $t('word35') }}</span>
            </button>

            <!-- язык: флаг и название текущего — сразу понятно, что тут меняется -->
            <button class="nnav__item" @click="sheet = true" :aria-label="$t('word36') + ': ' + currentLang.name">
                <span class="nnav__ico">
                    <img :src="currentLang.flag" class="nnav__flag" width="22" height="22" alt="">
                </span>
                <span class="nnav__lbl">{{ currentLang.short }}</span>
            </button>

            <button class="nnav__item" :class="{ 'is-on': isCart, 'has-items': cartCount }" :aria-current="isCart ? 'page' : null"
                    @click="$router.push({ name: 'cart' })">
                <span class="nnav__ico">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M5 8h14l-1.2 11.1a1.6 1.6 0 0 1-1.6 1.4H7.8a1.6 1.6 0 0 1-1.6-1.4L5 8Z"/><path d="M9 10.5V7a3 3 0 0 1 6 0v3.5"/>
                    </svg>
                    <b v-if="cartCount" class="nnav__badge">{{ cartCount }}</b>
                </span>
                <span class="nnav__lbl">{{ $t('word37') }}</span>
            </button>
        </div>
    </nav>

    <!-- ШТОРКА ВЫБОРА ЯЗЫКА -->
    <transition name="sheet">
        <div v-if="sheet" class="sheet" @click.self="sheet = false">
            <div class="sheet__box">
                <div class="sheet__grab"></div>
                <div class="sheet__head">
                    <p>{{ $t('word36') }}</p>
                    <button class="sheet__x" @click="sheet = false" :aria-label="$t('m_close')">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
                            <path d="M6 18L18 6M6 6l12 12"/>
                        </svg>
                    </button>
                </div>
                <div class="sheet__list">
                    <button v-for="l in shownLangs" :key="l.code" class="lang"
                            :class="{ 'is-on': current === l.code }" @click="pick(l.code)">
                        <img :src="l.flag" width="28" height="28" alt="">
                        <span>{{ l.name }}</span>
                        <svg v-if="current === l.code" class="lang__ok" viewBox="0 0 24 24" fill="none"
                             stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M5 12.5l4.5 4.5L19 7.5"/>
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    </transition>
</div>
</template>

<script>
import ru from '@/assets/flags/ru.png'
import uz from '@/assets/flags/uz.png'
import en from '@/assets/flags/en.png'
import tr from '@/assets/flags/tr.png'
import kz from '@/assets/flags/kz.png'
import kg from '@/assets/flags/kg.png'
import tj from '@/assets/flags/tj.png'
import cn from '@/assets/flags/cn.png'
import ko from '@/assets/flags/ko.png'
import es from '@/assets/flags/es.png'
import ar from '@/assets/flags/ar.png'
import hi from '@/assets/flags/hi.png'

export default {
    data() {
        return {
            sheet: false,
            langs: [
                { code: 'ru', name: 'Русский',   short: 'Русский', flag: ru },
                { code: 'uz', name: 'Oʻzbekcha', short: 'Oʻzbek',  flag: uz },
                { code: 'en', name: 'English',   short: 'English', flag: en },
                { code: 'tr', name: 'Türkçe',    short: 'Türkçe',  flag: tr },
                { code: 'kz', name: 'Қазақша',   short: 'Қазақ',   flag: kz },
                { code: 'kg', name: 'Кыргызча',  short: 'Кыргыз',  flag: kg },
                { code: 'tj', name: 'Тоҷикӣ',    short: 'Тоҷикӣ',  flag: tj },
                { code: 'cn', name: '中文',       short: '中文',     flag: cn },
                { code: 'ko', name: '한국어',     short: '한국어',   flag: ko },
                { code: 'es', name: 'Español',   short: 'Español', flag: es },
                { code: 'ar', name: 'العربية',   short: 'العربية', flag: ar },
                { code: 'hi', name: 'हिन्दी',      short: 'हिन्दी',    flag: hi },
            ],
        }
    },

    computed: {
        current()   { return this.$store.state.current_lang },
        // только языки, на которые ресторан перевёл меню (иначе гость увидит пустые названия)
        shownLangs() {
            const avl = (this.$store.state.vendor && this.$store.state.vendor.avl) || {}
            const on = this.langs.filter(l => avl[l.code] || l.code === this.current)
            return on.length > 1 ? on : this.langs
        },
        cartCount() { return this.$store.getters.cartTotalQuantity },
        // «Меню» подсвечено и на самой странице меню, и на карточке блюда
        isMenu()    { return ['vendor', 'product', 'vendor_new', 'product_new'].includes(this.$route.name) },
        isAbout()   { return ['about', 'about_new'].includes(this.$route.name) },
        isCart()    { return ['cart', 'checkout'].includes(this.$route.name) },
        currentLang() { return this.langs.find(l => l.code === this.current) || this.langs[0] },
    },

    watch: {
        // шторка не должна оставлять страницу заблокированной
        sheet(open) { document.body.style.overflow = open ? 'hidden' : '' },
    },

    beforeUnmount() { document.body.style.overflow = '' },

    methods: {
        go(name) {
            // повторное нажатие на «Меню» на самом меню — наверх
            if (this.$route.name === name) window.scrollTo({ top: 0, behavior: 'smooth' })
            else this.$router.push({ name })
        },
        pick(code) {
            if (code === this.current) return
            localStorage.setItem('currentLang', code)
            location.reload()
        },
    },
}
</script>

<style scoped>
.nnav {
    position: fixed; left: 0; right: 0; bottom: 0; z-index: 30;
    background: rgba(255, 255, 255, .96);
    backdrop-filter: saturate(180%) blur(18px); -webkit-backdrop-filter: saturate(180%) blur(18px);
    box-shadow: 0 -1px 0 var(--y-line), 0 -8px 24px rgba(29, 34, 48, .05);
    padding-bottom: env(safe-area-inset-bottom, 0px);   /* «домашняя полоска» iPhone */
}
.nnav__inner {
    max-width: 560px; margin-inline: auto;
    display: grid; grid-template-columns: repeat(4, 1fr); gap: 4px; padding: 6px 10px 6px;
}
.nnav__item {
    display: flex; flex-direction: column; align-items: center; gap: 3px; min-width: 0;
    border: 0; background: none; padding: 4px 2px; cursor: pointer;
    color: var(--y-ink-3); transition: color .15s;
}
/* активная вкладка — плашка под иконкой, жирная подпись */
.nnav__ico {
    position: relative; display: grid; place-items: center; width: 56px; height: 32px; border-radius: 999px;
    transition: background-color .2s var(--y-ease);
}
.nnav__item.is-on { color: var(--y-ink); }
.nnav__item.is-on .nnav__ico { background: #e9ecf3; }
.nnav__ico svg { width: 23px; height: 23px; transition: transform .2s var(--y-ease); }
.nnav__item:active .nnav__ico { transform: scale(.94); }
.nnav__flag { width: 22px; height: 22px; border-radius: 50%; object-fit: cover; box-shadow: 0 0 0 1.5px #fff, 0 0 0 2.5px var(--y-line); }

.nnav__badge {
    position: absolute; top: -4px; inset-inline-end: 6px; min-width: 19px; height: 19px; padding: 0 5px;
    border-radius: 999px; background: var(--y-anor); color: #fff;
    font-size: 11px; font-weight: 700; line-height: 19px; text-align: center;
    font-variant-numeric: tabular-nums; box-shadow: 0 0 0 2px #fff;
}
.nnav__item.has-items:not(.is-on) { color: var(--y-ink-2); }
.nnav__lbl {
    max-width: 100%; font-size: 11.5px; font-weight: 500; line-height: 1.2;
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.nnav__item.is-on .nnav__lbl { font-weight: 700; }

/* ---------- шторка выбора языка ---------- */
.sheet { position: fixed; inset: 0; z-index: 40; display: flex; align-items: flex-end; background: rgba(29, 34, 48, .42); }
.sheet__box {
    width: 100%; max-width: 560px; margin-inline: auto; max-height: 82vh;
    display: flex; flex-direction: column; background: #fff; border-radius: 22px 22px 0 0;
    padding: 8px 16px calc(18px + env(safe-area-inset-bottom, 0px));
}
.sheet__grab { width: 38px; height: 4px; border-radius: 99px; background: #d7dae1; margin: 4px auto 12px; }
.sheet__head { display: flex; align-items: center; justify-content: space-between; padding-bottom: 12px; }
.sheet__head p { font-size: 1.125rem; font-weight: 700; letter-spacing: -.01em; }
.sheet__x { width: 32px; height: 32px; padding: 7px; border: 0; border-radius: 50%; background: var(--y-mist); color: var(--y-ink-2); cursor: pointer; }

.sheet__list { overflow-y: auto; display: grid; grid-template-columns: 1fr 1fr; gap: 8px; padding-bottom: 4px; }
.lang {
    display: flex; align-items: center; gap: 10px; width: 100%; min-height: 52px; padding: 10px 12px;
    border: 0; border-radius: 14px; background: var(--y-mist); color: var(--y-ink);
    font-size: .9375rem; font-weight: 500; text-align: start; cursor: pointer;
    transition: background-color .15s, box-shadow .15s;
}
.lang:active { background: #e9ebf0; }
.lang.is-on { background: #fff; box-shadow: inset 0 0 0 2px var(--y-ink); font-weight: 600; }
.lang img { flex: none; width: 28px; height: 28px; border-radius: 50%; object-fit: cover; }
.lang span { flex: 1; min-width: 0; }
.lang__ok { flex: none; width: 18px; height: 18px; }

.sheet-enter-active, .sheet-leave-active { transition: opacity .22s ease; }
.sheet-enter-active .sheet__box, .sheet-leave-active .sheet__box { transition: transform .3s var(--y-ease); }
.sheet-enter-from, .sheet-leave-to { opacity: 0; }
.sheet-enter-from .sheet__box, .sheet-leave-to .sheet__box { transform: translateY(100%); }
</style>
